module.exports = __webpack_public_path__ + "static/media/checkmark.9cfc0be4.svg";